import React, { useCallback } from 'react';
import Text from 'fe-design-base/atoms/Text';
import Alert from 'fe-design-base/molecules/Alert';
import Link from 'fe-design-base/molecules/Link';
import { useIsEmbedded } from 'hooks/useIsEmbedded';
import PropTypes from 'prop-types';

import { toI18n } from 'util/i18n';

const MissingPaidBreaks = ({ paid, isMobile }) => {
  const isEmbedded = useIsEmbedded();

  const handleSettingsClick = useCallback(
    e => {
      e.preventDefault();

      if (window.cloverDashKit && isEmbedded) {
        window.cloverDashKit.sendMessage('navigation', {
          location: 'settings.time_clock',
          path: 'breaks_and_compliance',
        });
      } else {
        window.location.href = '/settings/time_tracking/breaks';
      }
    },
    [isEmbedded]
  );

  return (
    <Alert
      variant="info"
      action={
        <Link size="small" onClick={handleSettingsClick}>
          {toI18n('timecard_modal_v3.timebreaks_section.settings')}
        </Link>
      }
    >
      <Text variant={isMobile ? 'bodySm' : 'body'}>
        {toI18n(
          `timecard_modal_v3.timebreaks_section.missing_${
            paid ? '' : 'un'
          }paid_breaks`
        )}
      </Text>
    </Alert>
  );
};

MissingPaidBreaks.propTypes = {
  paid: PropTypes.bool.isRequired,
  isMobile: PropTypes.bool.isRequired,
};

export default MissingPaidBreaks;
